<template>
    <div class="device-list">
        <div class="label">
            设备概览表
        </div>
        <div>
            <div v-if="Data && Data.device_list">
                <el-carousel indicator-position="outside" ref="carousel" :index="carouselIndex" trigger="click"
                    height="85vh" :interval="5000" loop autoplay>
                    <el-carousel-item v-for="(list,ii) in showList" :name="`key_`+ii" :key="ii">
                        <div>
                            <el-row :gutter="20">
                                <el-col v-for="(item,index) in list" :key="index" :span="6">
                                    <div style="position: relative;margin-top: 15px;" :class="{'is_end':item.is_end}">
                                        <img style="width: 100%;" src="/static/images/home/count/bg.png" alt="">
                                        <div class="box">
                                            <div class="left">
                                                <div class="name-div">
                                                    <div class="name">
                                                        {{item.install_address}}
                                                    </div>
                                                    <div class="signal" style="width: 30px;">
                                                        <img style="width: 30px;"
                                                            :src="`/static/signal/xinhaoqiangdu`+item.signal+`.png`"
                                                            alt="">
                                                    </div>
                                                </div>
                                                <div class="">
                                                    【{{item.device_model_name}}】
                                                </div>
                                                <div class="" style="color: #7AC756;">
                                                    制水总量：{{item.total_pure_water}} L
                                                </div>
                                                <div class="box-row">
                                                    <div class="">
                                                        滤芯：<span v-if="item.filter_status"
                                                            class="is-success">正常</span><span v-else
                                                            class="is-danger">换芯</span>
                                                    </div>
                                                    <div class="" style="padding-left: 30px;">
                                                        <span v-if="item.device_error==0">故障：无</span>
                                                        <span v-else class="is-danger">{{item.error}}</span>
                                                    </div>
                                                </div>
                                                <div class="">
                                                    <div class="box-row">
                                                        <div class="">
                                                            纯净水：{{item.jingshui_tds}}
                                                        </div>
                                                        <div v-if="item.rw_tds_show===1" class=""
                                                            style="padding-left: 30px;">
                                                            自来水：{{item.yuanshui_tds}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="">
                                                    加热累计：{{item.num1_time}}
                                                </div>
                                            </div>
                                            <div class="right">
                                                <div class="">
                                                    <img class="img" :src="item.device_model_img" alt="" />
                                                </div>
                                                <div class="temp">
                                                    {{item.water_temperature}} <span
                                                        style="font-size: 16px;color: #fff;">℃</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>


<script>
    import {
        UserStore
    } from '@/utils/Mixin'
    export default {
        mixins: [UserStore],
        data() {
            return {
                carouselIndex: 0
            }
        },
        props: {
            carouselUpdate: 0
        },
        watch: {
            carouselUpdate(value) {
                // console.log('carouselUpdate', value)
                // this.$refs.carousel.setActiveItem(this.carouselIndex)
            },
        },
        computed: {
            showList() {
                function chunkArray(array, chunkSize) {
                    let result = [];
                    for (let i = 0; i < array.length; i += chunkSize) {
                        result.push(array.slice(i, i + chunkSize));
                    }
                    return result;
                }
                if (this.Data && this.Data.device_list) {
                    return chunkArray(this.Data.device_list, 20)
                } else {
                    return []
                }
            }
        },
        mounted() {},
        methods: {
            changeCarousel(e) {}
        }
    }
</script>

<style lang="less" scoped>
    ::v-deep .el-carousel__indicators--horizontal {
        position: absolute;
        bottom: 5px;
        text-align: center;
        left:20%;

        .el-carousel__indicator--horizontal button {
            width: 6px;
            height: 6px;
            background: #ffffff;
            border-radius: 50%;
            opacity: 0.5;
        }

        .el-carousel__indicator--horizontal.is-active button {
            width: 14px;
            height: 6px;
            background: #ffffff;
            opacity: 1;
            border-radius: 10px;
        }
    }

    .device-list {


        .is_end {
            background-color: #999;
        }

        .box {
            .right {
                width: 90px;
                padding: 15px 0;
                padding-right: 15px;
                text-align: right;

                .img {
                    height: 60px;
                }

                .temp {
                    line-height: 60px;
                    font-size: 20px;
                    color: #EF9D27;
                }
            }

            .left {
                width: 100%;

                .is-danger {
                    color: red;
                }

                .is-success {
                    color: #7AC756;
                }

                .box-row {
                    display: flex;
                }

                .name-div {
                    .icon {
                        width: 20px;
                        height: 20px;
                    }

                    .name {
                        width: 100%;
                    }

                    display: flex;
                }

                padding: 15px;
            }

            line-height: 24px;
            font-size:16px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            color: #fff;
            display: flex;
            justify-content: space-between;
        }
    }
</style>
